
import { FunctionArgumentType, FunctionPlugin } from './FunctionPlugin';
export class DegreesPlugin extends FunctionPlugin {
    degrees(ast, state) {
        return this.runFunction(ast.args, state, this.metadata('DEGREES'), (arg) => arg * (180 / Math.PI));
    }
}
DegreesPlugin.implementedFunctions = {
    'DEGREES': {
        method: 'degrees',
        parameters: [
            { argumentType: FunctionArgumentType.NUMBER }
        ]
    },
};
